import radhaGiridhariji from "../../assets/images/radhaGiridhariji.png";
import founderImage from "../../assets/images/founder.png";
import chantImage from "../../assets/images/chant.png";
import krishnaImage from "../../assets/images/krishna.jpg";
import history1Image from "../../assets/images/history-1.jpg";
import history2Image from "../../assets/images/history-2.jpg";
import history3Image from "../../assets/images/history-3.jpg";
import founderAcharya from "../../assets/images/founder-acharya.png";
import goal from "../../assets/images/goal.jpg";
import philosophyImg from "../../assets/images/philosophy.jpg";
import about1Image from "../../assets/images/about1.jpg";
import about2Image from "../../assets/images/about2.jpg";
import about3Image from "../../assets/images/about3.jpg";

export const aboutUs = [
  "Welcome to Sri Sri Radha Giridhariji Temple, dedicated to the worship of Lord Krishna and the promotion of spiritual awareness among people. His Divine Grace A.C.Bhaktivedanta Swami Prabhupada founded the International Society of Krishna Consciousness (ISKCON), also known as the Hare Krishna Movement, in 1966. ISKCON is a worldwide organisation of devotees of Lord Krishna, the Supreme Personality of Godhead, with 10,000 temple devotees and 250,000 congregational devotees as members. Over the course of four decades, ISKCON has expanded to include over 350 temples, 60 rural communities, 50 schools, and 60 restaurants. One of the primary goals of ISKCON is to promote societal well-being by teaching the science of Krishna consciousness as taught in the Bhagavad-Gita and other timeless Vedic scriptures.",
  "Our mission is to spread the teachings of Lord Krishna and the Vaishnava tradition to all those who seek spiritual knowledge and enlightenment. We believe that the path of devotion to Lord Krishna is the key to achieving inner peace and happiness in life.",
  "We offer a wide range of religious and spiritual activities for visitors to participate in, including kirtans, bhajans, and discourses on the teachings of Lord Krishna. Our programs are designed to help people connect with their inner selves and develop a deeper understanding of the spiritual world.",
  "Our temple is located in the town of Vallabh Vidya Nagar in the Anand district of the Indian state of Gujarat.",
];

export const histories = [
  "International Society for Krishna Consciousness), also known as the Hare Krishna movement, is a worldwide spiritual organization that was founded in 1966 by A.C. Bhaktivedanta Swami Prabhupada. The movement is based on the teachings of the Bhagavad-gita and the Srimad Bhagavatam, two ancient Hindu scriptures that describe the philosophy of Krishna consciousness.",
  "The roots of ISKCON can be traced back to the early 20th century, when a young boy named Abhay Charan De (later known as A.C. Bhaktivedanta Swami Prabhupada) was born in Calcutta, India. Abhay Charan De was deeply influenced by his spiritual teacher, Bhaktisiddhanta Sarasvati Thakura, who urged him to spread the teachings of Lord Krishna to the Western world.",
  "In 1965, at the age of 70, A.C.Bhaktivedanta Swami Prabhupada set sail for New York City with only a few dollars in his pocket and a crate of books containing his translations and commentaries on the Bhagavad-gita. He arrived in America alone and without any contacts or resources, but he was determined to fulfill his spiritual master's wishes.",
  "After several months of struggle and hardship, A.C. Bhaktivedanta Swami Prabhupada established the first ISKCON temple in New York City in 1966. The movement quickly gained popularity among young people who were seeking an alternative to the materialistic culture of the 1960s.",
  "By the early 1970s, ISKCON had spread to other parts of the world, including Europe, Australia, and South America. The movement's emphasis on vegetarianism, meditation, and devotion to Lord Krishna resonated with people from all walks of life, and ISKCON grew into a global spiritual community.",
  "Over the years, ISKCON movement has made significant contributions to the fields of spirituality, vegetarianism, and sustainable living.",
  "Today, ISKCON has hundreds of temples, ashrams, and centers around the world, and its members continue to spread the teachings of Lord Krishna through various activities, including kirtans, festivals, and humanitarian projects. The movement remains a vibrant and important part of the global spiritual landscape, attracting seekers of all ages and backgrounds who are drawn to its message of love, compassion, and devotion.",
];

export const goals = [
  "When Srila Prabhupada established in July 1966 in New York Krsna consciousness movement (ISKCON), he set its seven goals:",
  "1. To systematically spread spiritual knowledge in the whole society and educate all people in principles of spiritual life to check the imbalance of life values and to achieve real unity and peace in the world.",
  "2. To spread Krsna consciousness in the way it is revealed in the Bhagavad-gita and Srimad-Bhagavatam.",
  "3. To bring together members of the movement and lead them to Krsna, the original person, and in this way develop in them and the whole humanity the idea that every soul is part and parcel of God (Krsna).",
  "3. To bring together members of the movement and lead them to Krsna, the original person, and in this way develop in them and the whole humanity the idea that every soul is part and parcel of God (Krsna).",
  "4. To teach and support sankirtana movement, congregational chanting of the holy names of God, as it is revealed in the teaching of Lord Sri Caitanya Mahaprabhu.",
  "5. To develop places of pilgrimage related to the pastimes of Lord Krsna for the benefit of members and the whole society.",
  "6. To associate members for the purpose of teaching a more simple and natural way of life.",
  "7. To print and spread periodical publications, books and other literature to fulfill above-mentioned goals.",
];

export const philosophies = [
  "The philosophy of ISKCON is like a beautiful flower, with each petal representing a different aspect of the teachings of Lord Krishna. At its core, ISKCON is a spiritual movement that emphasizes the importance of love, compassion, and devotion to God.",
  "One petal of this flower is the belief that we are all eternal spiritual beings, temporarily residing in material bodies. According to ISKCON philosophy, our true nature is pure and spiritual, and our ultimate goal is to realize this nature and return to our eternal home in the spiritual world.",
  "Another petal of the ISKCON flower is the importance of karma and reincarnation. The movement teaches that our actions in this life determine our future destiny, and that we will continue to take birth in different forms until we achieve spiritual perfection.",
  "A third petal of the ISKCON flower is the practice of bhakti-yoga, or devotional service. This involves developing a personal relationship with God through chanting the Hare Krishna mantra, reading scripture, and engaging in acts of service and devotion.",
  "Yet another petal of the ISKCON flower is the importance of compassion and service to others. The movement believes that by serving others and alleviating their suffering, we can purify our hearts and develop a deeper connection with God.",
  "Together, these petals form a beautiful and intricate philosophy that offers a path to spiritual fulfillment and inner peace. ISKCON teaches that by cultivating love and devotion to God, and by serving others with compassion and humility, we can achieve our ultimate goal of spiritual liberation and eternal happiness. It is a philosophy that transcends all boundaries of race, religion, and nationality, and offers a message of hope and inspiration to people all over the world.",
];

export const founders = [
  "Srila A.C. Bhaktivedanta Swami Prabhupada was a spiritual master, a founder-acharya of the International Society for Krishna Consciousness (ISKCON), and a profound scholar of the Vedic scriptures. Born Abhay Charan De in Calcutta, India, in 1896, and spent his early life studying the Vedic scriptures and practicing devotional service to Lord Krishna.",
  "In 1965, at the age of 69, Srila Prabhupada boarded a cargo ship bound for New York City with only a few belongings and a burning desire to spread the teachings of Lord Krishna to the Western world, as per the instructions of his spiritual master Srila Bhaktisiddhanta Saraswati Goswami Maharaj Prabhupada. Despite numerous obstacles and setbacks, he persevered, living in poverty and facing countless challenges as he worked tirelessly to establish the first ISKCON temple in New York City.",
  "Over the next 11 years, Srila Prabhupada traveled extensively, establishing temples, ashrams, and centers around the world and inspiring countless individuals to embrace the path of bhakti-yoga. His teachings on love, compassion, and devotion to God continue to resonate with people of all backgrounds, and his legacy has touched the lives of millions.",
  "Srila Prabhupada's contributions to the world of spirituality and religion are immeasurable. Through his translations and commentaries on the Bhagavad-gita and Srimad Bhagavatam, he has provided a profound understanding of the ancient wisdom of the Vedic scriptures. His emphasis on the importance of devotional service and compassion for all living beings has inspired countless individuals to embrace a life of spiritual practice and service to others.",
  "Srila Prabhupada's teachings and example continue to inspire new generations of seekers and spiritual aspirants, and his legacy lives on through the vibrant and growing ISKCON movement that he founded. His dedication, wisdom, and unwavering commitment to the path of Krishna consciousness remain an inspiration to all who seek the truth and meaning of life.",
  "Srila Prabhupada Chronology",
  "1954 Left family, vanaprastha",
  "1956 Vrindavan residence, Vamsi Gopal temple",
  "1959 Begins translating Srimad Bhagavatam in Delhi",
  "July Moves upstairs Radha-Damodara temple",
  "Sept. 17, Takes sannyasa, renounced order of life",
  "1960 Fall Publishes first book, paperback Easy Journey to Other Planets",
  "1962 July Moves into downstairs rooms at Radha-Damodara",
  "Sept. Publishes Volume one, Srimad Bhagavatam in Delhi",
  "1963 December Publishes volume two Srimad Bhagavatam",
  "1964 December Publishes volume three Srimad Bhagavatam",
  "1965 August 13, Leaves Calcutta on Jaladuta bound for America",
  "1967 Returns to Radha-Damodara",
  "1971 Visits Radha-Damodara and Vrindavan with forty disciples",
  "1972 Kartik at Radha-Damodara, delivers famous Nectar of Devotion Lectures",
  "1977 Enters the eternal lila of Radha and Krishna in Goloka Vrindavan.",
];

export const carouselImages = [
  {
    id: 1,
    image: radhaGiridhariji,
  },
  {
    id: 2,
    image: founderImage,
  },
  {
    id: 3,
    image: chantImage,
  },
  {
    id: 4,
    image: krishnaImage,
  },
];

export const historyImages = [
  {
    id: 1,
    image: history1Image,
  },
  {
    id: 2,
    image: history2Image,
  },
  {
    id: 3,
    image: history3Image,
  },
];

export const aboutImages = [
  {
    id: 1,
    image: about1Image,
  },
  { id: 2, image: about2Image },
  { id: 3, image: about3Image },
];

export const titleTiles = [
  {
    title: "About Us",
    images: aboutImages,
    paragraphs: aboutUs,
  },
  {
    title: "History",
    images: historyImages,
    paragraphs: histories,
  },
];

export const sections = [
  {
    title: "Goals of Iskcon",
    image: goal,
    paragraphs: goals,
  },
  {
    title: "Philosophy",
    image: philosophyImg,
    paragraphs: philosophies,
  },
  {
    title: "Founder",
    image: founderAcharya,
    paragraphs: founders,
  },
];
